import { Box, Stack, Typography } from "@mui/joy";
import { useSupplierTooltipQuery } from "../../../../__generated__/types-and-hooks";
import SupplierRef from "../../../../components/SupplierRef";
import { CountryFlag } from "../../../../components/CountryFlag";

export interface SupplierTooltipProps {
  teamSlug: string;
  supplier: {
    uniqueId: string;
    name: string;
  };
}

export default function SupplierTooltip({
  teamSlug,
  supplier,
}: SupplierTooltipProps) {
  const { data } = useSupplierTooltipQuery({
    variables: { uniqueId: `${supplier.uniqueId}` },
  });

  const supplierInfo = data?.supplier_by_id;
  if (!supplierInfo) return null;

  return (
    <Box
      gap={1}
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "auto",
        maxWidth: 320,
        p: 1,
        textAlign: "left",
        margin: "auto",
      }}
    >
      <Typography level="title-lg">{supplierInfo.name}</Typography>
      <SupplierRef supplierRef={supplierInfo.uniqueId} teamSlug={teamSlug} />
      <Stack gap={1}>
        {supplierInfo.addressLine1 && (
          <Typography level="body-sm">{supplierInfo.addressLine1}</Typography>
        )}
        {supplierInfo.addressLine2 && (
          <Typography level="body-sm">{supplierInfo.addressLine2}</Typography>
        )}
        <Stack direction="row" gap={1}>
          {supplierInfo.city && (
            <Typography level="body-sm">{supplierInfo.city}</Typography>
          )}
          {supplierInfo.state && (
            <Typography level="body-sm">{supplierInfo.state}</Typography>
          )}
          {supplierInfo.postalCode && (
            <Typography level="body-sm">{supplierInfo.postalCode}</Typography>
          )}
        </Stack>
        {supplierInfo.countryCode && (
          <CountryFlag code={supplierInfo.countryCode} />
        )}
      </Stack>
    </Box>
  );
}
